import React from 'react';

import FilterSelect, { FilterSelectValue } from '@/components/filter-select/FilterSelect';
import { FilterSelectType } from '@/constants/enums';
import { DepartmentSlim } from '@/types/department.types';
import { DropdownAction } from '@/types/ui.types';

interface DepartmentsDropdownProps {
  departmentList: DepartmentSlim[];
  departmentChangeHandler?: (values: number[], action?: DropdownAction) => void;
  departmentListCloseHandler?: (values: number[]) => void;
  departmentListOpenHandler?: () => void;
  isLoading?: boolean;
  isRequired?: boolean;
  noOptionsMessage?: string;
  selectedIds?: number[];
}

const DepartmentsDropdown = (props: DepartmentsDropdownProps): React.JSX.Element => {
  const {
    departmentList,
    departmentChangeHandler,
    departmentListCloseHandler,
    departmentListOpenHandler,
    isLoading = false,
    isRequired = false,
    noOptionsMessage,
    selectedIds = [],
  } = props;

  const [selectedDepartments, setSelectedDepartments] = React.useState<number[]>(selectedIds);

  const handleDepartmentsChange = (values: FilterSelectValue[], action?: DropdownAction) => {
    const departmentIds = values.map(({ value }) => value);

    setSelectedDepartments(departmentIds);
    
    if (departmentChangeHandler) {
      return departmentChangeHandler(departmentIds, action);
    }
  };

  const handleDepartmentListClose = React.useCallback(() => {
    if (departmentListCloseHandler) {
      return departmentListCloseHandler(selectedDepartments);
    }
  }, [departmentListCloseHandler, selectedDepartments]);

  return (
    <FilterSelect
      hasSelectAll={true}
      header={'Departments'}
      inputName={FilterSelectType.DEPARTMENTS}
      isLoading={isLoading}
      isMultiSelect={true}
      isRequired={isRequired}
      noOptionsMessage={noOptionsMessage}
      onChangeHandler={(values, action) => handleDepartmentsChange(values as FilterSelectValue[], action)}
      onCloseHandler={handleDepartmentListClose}
      onOpenHandler={departmentListOpenHandler}
      optionLabelKey={'departmentName'}
      options={departmentList}
      optionValueKey={'departmentId'}
      placeHolderText={'Select Department(s)'}
      selectedValues={selectedIds ?? selectedDepartments}
      testId={'department-select'}
    />
  );
};

export default DepartmentsDropdown;
